import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppService } from './services/app/app.service';
import { RestService } from './services/rest/rest.service';
import { Log } from './core/logging/log';

@Component({
    template: '<div></div>',
    selector: 'redirect-root',
})
export class RedirectComponent implements OnInit {

    constructor(
        public appService: AppService,
        private restService: RestService,
        private route: ActivatedRoute) {}

        
    ngOnInit() {
        this.route.paramMap.subscribe(params => {
            const url = params.get('shortUrl');
            Log.debug('url', {url})
            this.redirection(url);
        });
    }

    redirection(url:string){
        this.restService.redirection(url).subscribe(result => {
          Log.debug('redirection', {url})
          window.location.href = result.urlRedirection;
        });
      }


}
